import IconArrowLeft from '@patientpattern/coat/icons/line/arrows/ArrowLeft';
import IconCloud01 from '@patientpattern/coat/icons/line/weather/Cloud01';
import Button from '@patientpattern/coat/ui/Button';
import Text from '@patientpattern/coat/ui/Text';
import {useNavigate} from 'react-router-dom';

import {redirectToDashboard} from '../utils';

import css from './NoMatch.module.scss';

const NoMatch = () => {
    const navigate = useNavigate();
    const onBackClick = () => {
        navigate(-1);
    };

    return (
        <div className={css.root}>
            <div className={css.content}>
                <div className={css.icon}>
                    <IconCloud01 className={css.cloud} />
                </div>
                <Text as="h1" group="display" size="xl" weight="semibold">
                    Page not found
                </Text>
                <Text size="xl">
                    The page you are looking for doesn&apos;t exist.
                </Text>
                <Text size="xl">Here are some helpful links:</Text>
                <div className={css.actions}>
                    <Button
                        icon={<IconArrowLeft />}
                        onClick={onBackClick}
                        testAttr="back"
                        variant="neutral"
                    >
                        Go Back
                    </Button>
                    <Button
                        className={css.home}
                        onClick={redirectToDashboard}
                        testAttr="home"
                        variant="primary"
                    >
                        Take me home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NoMatch;
